import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 4.5V4C3.22386 4 3 4.22386 3 4.5H3.5ZM3.5 20.5H3C3 20.7761 3.22386 21 3.5 21V20.5ZM19.5 20.5V21C19.7761 21 20 20.7761 20 20.5H19.5ZM19.5 4.5H20C20 4.22386 19.7761 4 19.5 4V4.5ZM11 4H3.5V5H11V4ZM3 4.5V20.5H4V4.5H3ZM3.5 21H19.5V20H3.5V21ZM20 20.5V13H19V20.5H20ZM9.85355 14.8536L19.8536 4.85355L19.1464 4.14645L9.14645 14.1464L9.85355 14.8536ZM19.5 4H15V5H19.5V4ZM19 4.5V9H20V4.5H19Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }